/**
 * Capitalizes the first letter of the provided string
 */
export const capitalizeString = (s: string) => {
  if (!s || s.length === 0) return s;
  const firstLetter = s[0].toUpperCase();
  const restOfString = s.slice(1);
  return firstLetter + restOfString;
};
